






























import { Component, Vue } from "vue-property-decorator";
import { SchemeType, Contract } from "@foxone/api/src/models/defi";
import { Getter } from "vuex-class";
import utils from "defi/utils";
import Tabs from "./Tabs.vue";
import NormalListItem from "./NormalListItem.vue";
import TermListItem from "./TermListItem.vue";
import DualNodeListItem from "./DualNodeListItem.vue";

@Component({
  components: {
    Tabs,
    NormalListItem,
    TermListItem,
    DualNodeListItem
  }
})
class ContractList extends Vue {
  @Getter("defi/contracts/getGroupedContracts")
  groupedContracts!: { [k: string]: Contract[] };

  activeIndex = 0;

  get activeType() {
    return this.groups[this.activeIndex].type;
  }

  get isTerm() {
    return this.activeType === SchemeType.TERM;
  }

  get isDualNode() {
    return this.activeType === SchemeType.DUAL_NODE;
  }

  get contracts() {
    return this.groupedContracts[this.activeType];
  }

  get groups() {
    return Object.keys(this.groupedContracts).map(t => ({
      type: t,
      text: this.getTypeText(t as SchemeType)
    }));
  }

  getTypeText(type: SchemeType) {
    return this.$t(utils.enums.getSchemeTypeMeta(type).text) as string;
  }
}
export default ContractList;
